var generateStyle = function generateStyle(componentTheme) {
  return {
    page: {
      padding: componentTheme.pagePadding
    },
    list: {
      listStyle: 'none',
      margin: "".concat(componentTheme.listTopMargin, " 0 0 0"),
      padding: '0'
    }
  };
};
export default generateStyle;